
export const deepCopy = (obj) => JSON.parse(JSON.stringify(obj));
